'use client'

import { CollectionListingNoFilter } from '@/app/[locale]/collection/_components/collection-listing-no-filter'
import { Tabs } from '@/components/ui/tabs'
import { useTranslations } from 'next-intl'
import { useState } from 'react'
import { CopperDenimContainer } from './container'

export const CopperDenimProducts = () => {
  const t = useTranslations()
  const [activeTab, setActiveTab] = useState<string>('')

  const TAB_OPTIONS = [
    {
      value: '',
      label: t('copper_denim_hardcode.products.tabs.all'),
    },
    {
      value: 'jeans-copper',
      label: t('copper_denim_hardcode.products.tabs.jeans'),
    },
    {
      value: 'ao-copper',
      label: t('copper_denim_hardcode.products.tabs.shirts'),
    },
    {
      value: 'mu-copper',
      label: t('copper_denim_hardcode.products.tabs.hats'),
    },
  ]

  return (
    <CopperDenimContainer>
      <div className='pt-2'>
        <h2 className='font-criteria text-2xl font-normal leading-8 text-neutral-900'>
          {t('copper_denim_hardcode.products.title')}
        </h2>

        <Tabs
          className='my-2 p-0'
          triggerClassName='text-sm leading-tight uppercase font-medium px-4 py-2 pt-2.5'
          variant='filter'
          options={TAB_OPTIONS}
          defaultValue={activeTab}
          onChange={(value) => setActiveTab(value)}
        />

        <CollectionListingNoFilter slug={activeTab || 'copper-denim'} />
      </div>
    </CopperDenimContainer>
  )
}
